<div class="dashboard--module-header">
    <h2 class="subheading-sm">Account balance <button class="info-btn focus-element" (click)="onInfoClick()" *ngIf="consumerHasPayg"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2><div class="ic-beware-wrapper" *ngIf="issues && issues.length > 0"><span class="ic-beware">!</span></div>
    
</div>
<div class="module--main">
    <div class="block-num text-center" *ngIf="latestBalance">
        <span class="lg">{{latestBalance.balance | currency:'GBP':'symbol':'1.2-2'}}</span>
        <span class="sm" *ngIf="isBalanceOwed && latestBalance.balance != 0">owed by consumer <br>updated {{latestBalance.balanceDate | date:'dd/MM/yyyy'}}</span>
        <span class="sm" *ngIf="!isBalanceOwed && latestBalance.balance != 0">Consumer is in credit <br>updated {{latestBalance.balanceDate | date:'dd/MM/yyyy'}}</span>
        <span class="sm" *ngIf="latestBalance.balance == 0">updated {{latestBalance.balanceDate | date:'dd/MM/yyyy'}}</span>
    </div>
    <div class="block-num text-center" *ngIf="!latestBalance">
        <span class="lg">N/A</span>
        <span class="sm">no account balance data</span>
    </div>
    <div class="block-detail">
        <table class="std-table stacked-sm">
            <thead>
            <th>Transaction</th>
            <th>Date</th>
            <th>Amount</th>
            <th>Balance</th>
            </thead>
            <tbody>
                <tr *ngFor="let historyAccount of historyAccounts">
                    <td data-label="Transaction">{{historyAccount.transactionName}}</td>
                    <td data-label="Date">{{historyAccount.dateCreated | date:'dd/MM/yyyy'}}</td>
                    <td data-label="Amount">{{historyAccount.amount | currency:'GBP':'symbol':'1.2-2'}}</td>
                    <td data-label="Balance">{{historyAccount.balance | currency:'GBP':'symbol':'1.2-2'}}</td>
                </tr>
            </tbody>
        </table>
        <app-pagination *ngIf="historyAccounts.length > 0" [page]="accountPage" [pages]="historyAccountsTotalPages" (pageChange)="pageSelected($event)"></app-pagination>
    </div>
</div>
